var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperienceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 17.5625V19.3125",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.5 17.5625C3.67421 20.9838 3.85667 22.7794 5.13113 23.9147C6.5132 25.1458 8.66896 25.1458 12.9804 25.1458H15.0196C19.3311 25.1458 21.4868 25.1458 22.8689 23.9147C24.1433 22.7794 24.3258 20.9838 24.5 17.5625",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.32106 12.2461C5.30358 16.016 9.77508 17.5625 13.9993 17.5625C18.2236 17.5625 22.6951 16.016 24.6776 12.2461C25.624 10.4465 24.9074 7.0625 22.5767 7.0625H5.42202C3.09128 7.0625 2.37472 10.4465 3.32106 12.2461Z",
    stroke: "#A461D8",
    strokeWidth: 1.65833
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.6673 7.0638L18.5643 6.70323C18.051 4.90651 17.7943 4.00815 17.1832 3.4943C16.5721 2.98047 15.7605 2.98047 14.1372 2.98047H13.8642C12.2409 2.98047 11.4292 2.98047 10.8181 3.4943C10.207 4.00815 9.95036 4.90651 9.437 6.70323L9.33398 7.0638",
    stroke: "#A461D8",
    strokeWidth: 1.65833
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceIcon);
export default __webpack_public_path__ + "static/media/experience-icon.90922724d80aaab1633189a731d9025b.svg";
export { ForwardRef as ReactComponent };